import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, safeNext } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { BrandLoader } from "@/components/brand/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        const next = safeNext(sessionStorage.getItem("cq_next"));
        sessionStorage.removeItem("cq_next");
        setUser(data); nav(next || "/command-centre", { replace: true });
      })
      .catch(() => { toast.error("Google sign-in failed. Please try again."); setUser(false); nav("/login", { replace: true }); });
  }, [location.hash, nav, setUser]);

  return <div data-testid="auth-callback"><BrandLoader label="Signing you in" /></div>;
}
